import { createContext } from "react";
import { DrawingTypeModel } from "../api/drawingApi";

interface DrawingId {
  name: string;
  type: DrawingTypeModel;
}

export const DrawingContext = createContext<DrawingId>({
  name: "",
  type: DrawingTypeModel.Drawing,
});
